import styled from '@emotion/styled';

export const ModalFileWrapper = styled.div`
  padding: 20px 0;
  .loading-msg {
    margin: 20px 0;
    color: grey;
  }
  img {
    width: 100%;
  }
`;
